import { Icon } from "@iconify/react";
import personOutline from "@iconify/icons-eva/person-outline";
import checkmarkSquareOutline from "@iconify/icons-eva/checkmark-square-outline";
import clockOutline from "@iconify/icons-eva/clock-outline";
import checkmarkCircle2Outline from "@iconify/icons-eva/checkmark-circle-2-outline";
import flip2Outline from "@iconify/icons-eva/flip-2-outline";
import peopleOutline from "@iconify/icons-eva/people-outline";
import edit2Outline from "@iconify/icons-eva/edit-2-outline";
import plusSquareOutline from "@iconify/icons-eva/plus-square-outline";
import creditCardOutline from "@iconify/icons-eva/credit-card-outline";
import globeOutline from "@iconify/icons-eva/globe-outline";

// ----------------------------------------------------------------------

const getIcon = (name) => <Icon icon={name} width={22} height={22} />;

export const sidebarAdminConfig = [
  {
    title: "Profile",
    path: "/profile/admin",
    icon: getIcon(personOutline)
  },
  {
    title: "Member",
    path: "/members/admin",
    icon: getIcon(peopleOutline)
  },
  {
    title: "Progress Report Approval",
    path: "/progress-report-approval/admin",
    icon: getIcon(checkmarkSquareOutline)
  },
  {
    title: "Research Period Extension",
    path: "/extension/admin",
    icon: getIcon(clockOutline)
  },
  {
    title: "Resubmission",
    path: "/resubmit/admin",
    icon: getIcon(edit2Outline)
  },
  {
    title: "Renewal of Fellowship Contract",
    path: "/renewal-fellowship/admin",
    icon: getIcon(flip2Outline)
  },
  {
    title: "Medical Insurance",
    path: "/medical-insurance/admin",
    icon: getIcon(plusSquareOutline)
  },
  {
    title: "Researcher Card",
    path: "/researcher-card/admin",
    icon: getIcon(creditCardOutline)
  },
  {
    title: "Visa Extension",
    path: "/visa-extension/admin",
    icon: getIcon(globeOutline)
  },

];

export const sidebarMentorConfig = [
  {
    title: "Profile",
    path: "/profile/mentor",
    icon: getIcon(personOutline)
  },
  {
    title: "Progress Report Approval",
    path: "/approve/mentor",
    icon: getIcon(checkmarkSquareOutline)
  },
  {
    title: "Research Period Extension",
    path: "/extension/mentor",
    icon: getIcon(clockOutline)
  },
  {
    title: "Checked",
    path: "/checked/mentor",
    icon: getIcon(checkmarkCircle2Outline)
  },
  {
    title: "Renewal of Fellowship Contract",
    path: "/renewal-fellowship/mentor",
    icon: getIcon(flip2Outline)
  }
];

export const sidebarPostDocConfig = [
  {
    title: "Profile",
    path: "/profile/post_doc",
    icon: getIcon(personOutline)
  },
  {
    title: "Progress Report",
    path: "/research-progress/post_doc",
    icon: getIcon(checkmarkSquareOutline)
  },
  {
    title: "Research Period Extension",
    path: "/extension-std/post_doc",
    icon: getIcon(clockOutline)
  },
  {
    title: "Renewal of Fellowship",
    path: "/renewal-std/post_doc",
    icon: getIcon(flip2Outline)
  }
];

export const sidebarPhD3yConfig = [
  {
    title: "Profile",
    path: "/profile/phd_3y",
    icon: getIcon(personOutline)
  },
  {
    title: "Progress Report",
    path: "/research-progress/phd_3y",
    icon: getIcon(checkmarkSquareOutline)
  },
  {
    title: "Research Period Extension",
    path: "/extension-std/phd_3y",
    icon: getIcon(clockOutline)
  }
];

export const sidebarPhD5yConfig = [
  {
    title: "Profile",
    path: "/profile/phd_5y",
    icon: getIcon(personOutline)
  },
  {
    title: "Progress Report Approval",
    path: "/research-progress/phd_5y",
    icon: getIcon(checkmarkSquareOutline)
  },
  {
    title: "Research Period Extension",
    path: "/extension-std/phd_5y",
    icon: getIcon(clockOutline)
  }
];
